module.exports = __webpack_public_path__ + "media/images/payments/alipay-1a8a9c6cfee1a4b081b898f3e315f4ec.svg";